import { useState } from "react";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import { ROW_COUNT, ROW_COUNT_MAX } from "../../helpers/variableHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { UsuariosExternosServices } from "../../services/UsuariosExternosServices";
import { Offcanvas } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { IAddRolesUsuario, IRolesUsuario, ISearchAllRolesUsuario } from "../../entities/IRolesUsuario";
import Select, { MultiValue } from "react-select";
import { IModulos } from "../../entities/IModulo";
import UserPicker from "../../controls/UserPicker";
import IUserPickerValue from "../../entities/helper/IUserPickerValue";
import { IComboboxOption } from "../../entities/helper/IComboboxOption";
import { IRoles } from "../../entities/IRoles";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import Loading from "../../cross/Loading";
const MySwal = withReactContent(Swal);

interface IAgregarUsuarioExternoProps {
  onClose: () => void;
  show: boolean;
  rolUsuarioEdit: IRolesUsuario | null;
  loading?: boolean;
}

const AgregarRolUsuario = ({ onClose, show, rolUsuarioEdit, loading = true }: IAgregarUsuarioExternoProps) => {
  const userInfo = cognitoUserToken();
  const pageSize = ROW_COUNT;
  const pageSizeMax = ROW_COUNT_MAX;
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(loading);
  const [userEdit, setUserEdit] = useState<IRolesUsuario | null>(rolUsuarioEdit);
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [listModulos, setListModulos] = useState<Array<IModulos>>([]);
  const [listRoles, setListRoles] = useState<Array<IRoles>>([]);

  const [selectedUser, setSelectedUser] = useState<IUserPickerValue | null>();
  const [selectedModulo, setSelectedModulo] = useState<MultiValue<IComboboxOption>>([]);
  const [selectedRol, setSelectedRol] = useState<MultiValue<IComboboxOption>>([]);
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  let params = {
    PAGINA: 1,
    PAGINADO: pageSize,
    ORDENADOPOR: "TITULO",
    ORIENTACION: "ASC",
  };
  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    if (userEdit) {
      await loadUser(userEdit);
    }
    setIsLoading(false);
  }, []);

  const formValidation = (value: IAddRolesUsuario) => {
    let arrErrors: Array<string> = [];
    let arrErrorsText: Array<string> = [];

    if (!value.USUARIO) {
      arrErrors.push("EMAIL");
    }
    if (value.ID_MODULO.length == 0) {
      arrErrors.push("MODULO");
    }
    if (value.ID_ROL.length == 0) {
      arrErrors.push("ROL");
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const guardar = async () => {
    let value: IAddRolesUsuario = {
      ID: userEdit?.ID,
      ACTIVO: true,
      USUARIO: selectedUser?.mail as string,
      USUARIO_DISPLAY: selectedUser?.name as string,
      ID_MODULO: selectedModulo?.map((m) => parseInt(m.value)),
      ID_ROL: selectedRol?.map((m) => parseInt(m.value)),
      CREADOR: currentUser?.email as string,
      CREADOR_DISPLAY: currentUser?.fullname as string,
    };

    if (formValidation(value)) {
      setIsLoading(true);
      let result = await UsuariosExternosServices.setRolUsuario(token, value);
      if (!result.ok) {
        MySwal.fire({
          html: (
            <div>
              <h3>Debe considerar lo siguiente:</h3>
              <p>{result.msg}</p>
            </div>
          ),
          text: "",
          icon: "error",
          showCloseButton: true,
        });
        setIsLoading(false);
      } else {
        onClose();
      }
    }
  };

  const handleChangeUsuario = async (usuario: IUserPickerValue | null) => {
    setSelectedUser(usuario);
    setIsLoading(true);
    if (usuario) {
      await loadUser({
        DISPLAY_NAME: usuario.name,
        EMAIL: usuario.mail,
        EXTERNO: usuario.externo,
      });

      setIsLoading(false);
    } else {
      setTimeout(() => {
        setUserEdit(null);
        setListModulos([]);
        setListRoles([]);
        setSelectedModulo([]);
        setSelectedRol([]);

        setIsLoading(false);
      }, 1500);
    }
  };

  const loadUser = async (userRol?: IRolesUsuario | null) => {
    if (userRol) {
      const isExterno = await UsuariosExternosServices.isUsuarioExterno(token, userRol.EMAIL as string);
      const usr: IUserPickerValue = {
        mail: userRol.EMAIL as string,
        name: userRol.DISPLAY_NAME as string,
        externo: isExterno,
      };

      setSelectedUser(usr);

      const pagination: ISearchAllRolesUsuario = {
        ...params,
        USUARIO_DISPLAY: userRol.EMAIL,
      };
      let result = await UsuariosExternosServices.getAllRolesUsuario(token, pagination);

      if (result.data.length > 0) {
        setUserEdit(result.data[0]);
        userRol = result.data[0];
        let resultModulos = await UsuariosExternosServices.getAllModulos(token, {
          ...params,
          PAGINADO: pageSizeMax,
          EXTERNO: isExterno,
        });
        setListModulos(resultModulos.data);
        setSelectedModulo(
          resultModulos.data?.map((m) => {
            return {
              label: m.TITULO,
              value: m.ID.toString(),
            };
          }) || []
        );
        let resultRoles = await UsuariosExternosServices.getAllRoles(token, {
          ...params,
          PAGINADO: pageSizeMax,
          ARRAY_ID_MODULO: resultModulos.data?.map((m) => m.ID).join(","),
          EXTERNO: isExterno,
        });

        setSelectedRol(
          resultRoles.data
            .filter((r) => userRol?.ID_ROLES?.includes(r.ID))
            .map((r) => {
              return {
                label: r.TITULO,
                value: r.ID.toString(),
              };
            })
        );
      } else {
        setSelectedRol([]);
        setIsLoading(true);
        if (usr) {
          let resultModulos = await UsuariosExternosServices.getAllModulos(token, {
            ...params,
            PAGINADO: pageSizeMax,
            EXTERNO: usr.externo,
          });
          setListModulos(resultModulos.data);
          setIsLoading(false);
          return resultModulos.data;
        }
      }
    }
  };

  const handleChangeModulo = async (modulos: MultiValue<IComboboxOption>, usr?: IUserPickerValue) => {
    setSelectedModulo(modulos);
    let result = await UsuariosExternosServices.getAllRoles(token, {
      ...params,
      PAGINADO: pageSizeMax,
      ARRAY_ID_MODULO: modulos.map((m) => m.value).join(","),
      EXTERNO: selectedUser?.externo || usr?.externo,
    });
    setListRoles(result.data);
    let roles = selectedRol.filter((s) => result.data.filter((r) => s.value == r.ID.toString()).length > 0);
    setSelectedRol(roles);
    return result.data;
  };

  const handleChangeRol = async (rol: MultiValue<IComboboxOption>) => {
    setSelectedRol(rol);
  };

  return (
    <Offcanvas show={show} onHide={onClose} placement={"end"} className="w-40 modalAgregarCausa">
      <Offcanvas.Header closeButton className="border-bottom">
        <Offcanvas.Title className="m-3 mb-1 colorTit">{userEdit ? "Editar" : "Agregar"} Rol Usuario</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="m-3">
        {isLoading ? (
          <>
            <Loading />-
          </>
        ) : (
          <div className="container-fluid mb-4">
            <button
              data-testid="btntest"
              hidden={true}
              onClick={() => {
                handleChangeUsuario({ name: "", mail: "", externo: false } as IUserPickerValue);
              }}></button>
            <div className="row mb-2 ajusteInput">
              <div className="col-12 mb-2 mt-1">
                <span className="text-danger">
                  <strong>(*)</strong>
                </span>
                <label>Nombre Usuario</label>
                <UserPicker
                  name={"detectadoPor"}
                  callback={(id, u) => {
                    handleChangeUsuario(u[0] || null);
                  }}
                  id={"detectadoPor"}
                  key={"1"}
                  multi={false}
                  disabled={false}
                  className={`${arrErrorEmpty.includes("EMAIL") && "error"} borderColorGris`}
                  defaultValue={
                    selectedUser
                      ? {
                          mail: selectedUser.name,
                          name: selectedUser.name,
                          externo: selectedUser.externo,
                        }
                      : []
                  }
                  //className={errorEmpty ? "error" : ""}
                />
                <span className="text-danger">
                  <strong>(*)</strong>
                </span>
                <label>Módulo</label>
                <Select
                  closeMenuOnSelect={false}
                  className={`${arrErrorEmpty.includes("MODULO") && "error"} borderColorGris`}
                  // defaultValue={[colourOptions[0], colourOptions[1]]}
                  defaultValue={
                    userEdit
                      ? (listModulos
                          .filter((m) => userEdit?.ID_MODULOS?.includes(m.ID))
                          .map((vcc) => ({
                            value: vcc.ID,
                            label: vcc.TITULO,
                          })) as any)
                      : []
                  }
                  isMulti
                  options={
                    listModulos.map((vcc) => ({
                      value: vcc.ID,
                      label: vcc.TITULO,
                    })) as any
                  }
                  onChange={(e) => {
                    handleChangeModulo(e);
                  }}
                  // styles={colourStyles}
                />
                <span className="text-danger">
                  <strong>(*)</strong>
                </span>
                <label>Rol</label>

                <Select
                  className={`${arrErrorEmpty.includes("ROL") && "error"} borderColorGris`}
                  isMulti
                  defaultValue={
                    userEdit
                      ? (listRoles
                          .filter((r) => userEdit?.ID_ROLES?.includes(r.ID))
                          .map((r) => ({
                            value: r.ID,
                            label: r.TITULO,
                          })) as any)
                      : []
                  }
                  options={selectedModulo?.map((m) => {
                    return {
                      label: m.label,
                      options: listRoles
                        .filter((r) => r.ID_MODULO == parseInt(m.value))
                        .map((r) => ({
                          value: r.ID,
                          label: r.TITULO,
                        })) as any,
                    };
                  })}
                  onChange={(e: MultiValue<IComboboxOption>) => {
                    handleChangeRol(e);
                  }}
                  value={selectedRol}
                  // formatGroupLabel={formatGroupLabel}
                />

                {isLoading || (
                  <section className="mt-5">
                    <button
                      type="button"
                      className="btn btn-primary btn-sm me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#modalGuardar"
                      onClick={() => {
                        guardar();
                      }}>
                      Guardar
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                      onClick={() => {
                        onClose();
                      }}>
                      Volver
                    </button>
                  </section>
                )}
              </div>
            </div>
          </div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AgregarRolUsuario;
